var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterYoutube(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.64,
    height: 16.63,
    viewBox: "0 0 23.64 16.63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #071d49;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.41,3.59s-.23-1.63-.94-2.35c-.9-.94-1.91-.95-2.37-1-3.31-.24-8.27-.24-8.27-.24h0S6.85,0,3.55,.24c-.46,.06-1.47,.06-2.37,1C.47,1.96,.24,3.59,.24,3.59c0,0-.24,1.92-.24,3.83v1.79c0,1.91,.24,3.83,.24,3.83,0,0,.23,1.63,.94,2.35,.9,.94,2.08,.91,2.61,1.01,1.89,.18,8.04,.24,8.04,.24,0,0,4.97,0,8.28-.24,.46-.06,1.47-.06,2.37-1,.71-.72,.94-2.35,.94-2.35,0,0,.24-1.91,.24-3.83v-1.79c0-1.91-.24-3.83-.24-3.83Zm-14.03,7.79V4.74l6.39,3.33-6.39,3.31Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterYoutube);
export default __webpack_public_path__ + "static/media/footer-youtube.91b9827a9c7b88d974937a15a71fd54b.svg";
export { ForwardRef as ReactComponent };